import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import DepositPlayersTable from './DepositPlayersTable';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import { API_FINANCE } from '../../../api/finance';
import useGetDepositInfo from '../../../hooks/site/finance/useGetDepositInfo';
import DepositsFilter from './DepositsFilter';
import { useAppSelector } from '../../../store';
import { useDispatch } from 'react-redux';
import { setDepositFilter, setDepositInfo } from '../../../store/apps/financeSlice';
import DefaultPagination from '../../../components/material-ui/pagination/DefaultPagination';
import { postOptions } from '../../../enums/enums';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { ENUM_CURRENCY } from '../../../components/shared/CurrencySelect';

export default function DepositPlayers() {
  const dispatch = useDispatch();
  const depositInfo = useAppSelector((state) => state.finance.deposit.info);
  const deposits = useAppSelector((state) => state.finance.deposit.info.list);
  const filter = useAppSelector((state) => state.finance.deposit.filter);

  const { statusHash, gates, updatePlayers } = useGetDepositInfo();
  const [alreadyShow, setAlreadyShow] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pageNo, setPageNo] = useState(depositInfo.pageNo || 1);
  const [pageSize, setPageSize] = useState(depositInfo.pageSize || postOptions[0].value);
  const [pageCount, setPageCount] = useState(depositInfo.pageCount || null);

  useEffect(() => {
    if (!pageNo) return;
    setPageNo(pageNo);
  }, [pageNo]);

  const fillDataRes = (data) => {
    dispatch(setDepositInfo(data));
    setPageNo(data.pageNo);
    setPageCount(data.pageCount);
  };

  const onFindRequestId = (payload) => {
    API_FINANCE.deposit
      .search({
        groupId: payload.groupId,
        pageNo: payload.pageNo,
        pageSize: payload.pageSize,
        sample: payload.requestIdFind
      })
      .then((e) => {
        const data = e.data.data;
        dispatch(setDepositFilter(payload));
        fillDataRes(data);
      })
      .catch(console.error)
      .finally(() => setBtnLoading(false));
  };

  const onSaveClick = (newPayload) => {
    setBtnLoading(true);
    setAlreadyShow(true);

    const payload = { pageNo, pageSize, ...filter, ...newPayload };

    if (payload.requestIdFind?.length >= 3) {
      if (payload.requestIdFind !== filter.requestIdFind) payload.pageNo = 1;

      onFindRequestId(payload);
      return;
    }

    if (
      filter.groupId !== payload.groupId ||
      filter.userId !== payload.userId ||
      filter.dateFrom !== payload.dateFrom ||
      filter.dateTo !== payload.dateTo ||
      filter.gateway !== payload.gateway ||
      filter.status !== payload.status ||
      filter.source !== payload.source ||
      filter.currency !== payload.currency ||
      filter.requestIdFind?.length >= 3
    ) {
      payload.pageNo = 1;
    }

    const curPayload = { ...payload };
    delete curPayload.requestIdFind;
    if (curPayload.currency === ENUM_CURRENCY.all) curPayload.currency = null;

    API_FINANCE.deposit
      .list(curPayload)
      .then((e) => {
        const data = e.data.data;
        dispatch(setDepositFilter(payload));
        fillDataRes(data);
      })
      .catch(console.log)
      .finally(() => setBtnLoading(false));
  };

  return (
    <CusPageCardContainer title="Player deposits">
      <Stack display={'flex'} direction={'column'} gap={3}>
        <DepositsFilter
          gates={gates}
          statusHash={statusHash}
          btnLoading={btnLoading}
          updatePlayers={updatePlayers}
          onSaveClick={onSaveClick}
        />

        <DepositPlayersTable
          alreadyShow={alreadyShow}
          btnLoading={btnLoading}
          depositInfo={depositInfo}
          statusHash={statusHash}
          gates={gates}
          startPageNumber={pageNo * pageSize - pageSize + 1}
        />

        <ShowContainer condition={deposits?.length}>
          <DefaultPagination
            curPage={pageNo}
            pageCount={pageCount}
            selectRecord={pageSize}
            setCurPage={setPageNo}
            setSelectRecord={setPageSize}
            onFindClick={onSaveClick}
          />
        </ShowContainer>
      </Stack>
    </CusPageCardContainer>
  );
}
